module.exports = __webpack_public_path__ + "static/img_3-abce009212393ccaf2ac7835a7f3b8fd.png";